(function () {
  // Dynamic Announcement Bar - Structured.Agency
  document.addEventListener("DOMContentLoaded", function () {
    const firstAnnouncementBar = document.getElementsByClassName(
      "free-shipping-announcement"
    );
    const secondAnnouncementBar = document.getElementsByClassName(
      "free-gift-announcement"
    );

    async function updateAnnouncementBar() {
      try {
        const response = await fetch("/cart.js");
        const cart = await response.json();
        const subtotal = cart.total_price;

        // console.log(`Cart total is ${subtotal}`);

        let freeShippingMessage = "";
        let freeGiftMessage = "";
        let freeGift = 6000;
        let freeShipping = 5000;

        // Checking for free shipping - you need $50 or more

        if (subtotal < 1) {
          freeShippingMessage = `Spend $50 or more for FREE Shipping`;
        } else if (subtotal > freeShipping) {
          freeShippingMessage = `FREE shipping will be applied at checkout`;
        } else {
          freeShippingMessage = `Spend $${
            (freeShipping - subtotal) / 100
          } more for FREE Shipping`;
        }
        if (subtotal < 1) {
          freeGiftMessage = `Spend $60 or more for a FREE Gift`;
        } else if (subtotal > freeGift) {
          freeGiftMessage = `FREE Gift revealed at checkout`;
        } else {
          freeGiftMessage = `Spend $${
            (freeGift - subtotal) / 100
          } more for FREE Gift `;
        }

        Array.from(firstAnnouncementBar).forEach((element) => {
          element.textContent = freeShippingMessage;
        });
        Array.from(secondAnnouncementBar).forEach((element) => {
          element.textContent = freeGiftMessage;
        });
      } catch (error) {
        console.error("Error updating announcement:", error);
      }
    }

    document.addEventListener("cart:updated", updateAnnouncementBar);

    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (
          entry.name.includes("/cart/") &&
          ["xmlhttprequest", "fetch"].includes(entry.initiatorType)
        ) {
          updateAnnouncementBar();
        }
      });
    });

    observer.observe({ entryTypes: ["resource"] });

    updateAnnouncementBar();
  });
})();
